'use strict';
import $ from 'jquery';
import 'jquery-match-height';

export default class PricingBlock {
    static init() {
        $('.section-features-block').each((index, el) => {
            new PricingBlock($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.find('.features-table-column-header p').matchHeight();
        this.header = this.el.find('.features-table-header');
        if (this.header.length > 0) {
            $(window).on('resize', this.onResize.bind(this));
            $(window).on('scroll', this.onScroll.bind(this));
            this.headerOffsetTop = this.header.offset().top;
        }
    }

    onResize(e) {
        if (this.el.is(':visible')) {
            this.headerOffsetTop = this.header.offset().top;
        }
    }

    onScroll(e) {
        if (this.el.is(':visible')) {
            if ($(document).scrollTop() + this.getHeaderHeight() > this.headerOffsetTop - this.header.height()) {
                if (!this.header.hasClass('sticky')) {
                    this.header.addClass('sticky');
                    this.header.css('top', this.getHeaderHeight() + 'px');
                }
            } else {
                this.header.removeClass('sticky');
                this.header.css('top', 'auto');
            }
        }
    }

    getHeaderHeight() {
        let height = $('.main-header').height();
        if ($('#wpadminbar').length)
            height += $('#wpadminbar').height();
        return height;
    }
}